import ReactOnRails from "react-on-rails";

import Root from "../bundles/ReactHome/Root";

// This is how react_on_rails can see the ReactHome in the browser.
ReactOnRails.register({
  Root
});
